import { h } from 'preact';

const Footnotes = () => {
    return (
        <div className="l-section">
            <div className="l-container u-font-1 u-leading-5 u-txt-gray-80 dark:u-txt-gray-20">
                <div id="foot-1">
                    <sup>1</sup> Initial payment is a standard installment based on a simple daily
                    rate calculation rather than a several-month advance payment.
                </div>
                <div id="foot-2">
                    <sup>2</sup> Fees, when they occur, are spread over time and paid incrementally
                    - not up front.
                </div>
            </div>
        </div>
    );
};

export const Footnote = ({ id }: { id: string }) => {
    return <sup className="u-font-normal">{id}</sup>;
};

export default Footnotes;
